import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Seo from './Seo';
import ProductSidebar from './ProductSidebar';
import { useUser } from '../contexts/UserContext';
import LinkedInOptimizerPage from './LinkedInOptimizerPage';
import './LinkedInOptimizerLanding.css';

// Standalone LinkedIn Studio — the optimizer tool on its own clean page.
// Reached from the "Optimize my LinkedIn" CTA on the landing page instead of
// rendering the tool inline below the marketing content. The `.lol-studio`
// wrapper carries the same theme overrides the tool uses when embedded on the
// landing, so it stays visually consistent.
const LinkedInStudioPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  // Auth modal lives on the homepage; route there with a flag when needed.
  const setShowAuthModal = useCallback((show) => {
    if (show) navigate('/?openLogin=1');
  }, [navigate]);

  return (
    <div className="lol-page">
      <Seo
        title="LinkedIn Studio — Optimize Your Profile"
        description="Paste your LinkedIn profile, target a role, and get AI-rewritten headline, About, and experience with a profile-strength score — clean and distraction-free."
        path="/linkedin-studio"
      />
      <Header setShowAuthModal={setShowAuthModal} />
      <ProductSidebar user={user} setShowAuthModal={setShowAuthModal} />

      <section className="lol-studio lol-studio--page">
        <LinkedInOptimizerPage embedded />
      </section>
    </div>
  );
};

export default LinkedInStudioPage;
